export const templateVariableDisplayNames: Record<string, string> = {
  // grupy
  booking: 'rezerwacja',
  tour: 'wyjazd',
  client: 'klient',
  consent: 'umowa/zgoda',
  participants: 'uczestnicy',
  payments: 'płatności',

  // booking
  'booking.numer': 'numer',
  'booking.status': 'status',
  'booking.bookingDate': 'dataRezerwacji',
  'booking.totalPrice': 'cenaCałkowita',

  // tour
  'tour.name': 'nazwa',
  'tour.location': 'lokalizacja',
  'tour.startDate': 'dataRozpoczęcia',
  'tour.endDate': 'dataZakończenia',
  'tour.chatInviteLink': 'linkDoCzatu',

  // client
  'client.firstName': 'imię',
  'client.lastName': 'nazwisko',
  'client.email': 'email',
  'client.birthDate': 'dataUrodzenia',
  'client.address.street': 'adres.ulica',
  'client.address.city': 'adres.miasto',
  'client.address.postalCode': 'adres.kodPocztowy',
  'client.phone': 'telefon',
  // legacy (flat client.*) — kept in case other endpoints still return them
  'client.street': 'ulica',
  'client.city': 'miasto',
  'client.postalCode': 'kodPocztowy',
  'client.bookingCode': 'kodRezerwacji',
  'client.consentCode': 'kodZgody',
  'client.reservationDate': 'dataRezerwacji',

  // consent
  'consent.numer': 'numer',
  'consent.signedDate': 'dataPodpisu',

  // payments
  'payments.installmentsTable': 'tabelaRat',
  'payments.totalAmount': 'kwotaCałkowita',

  // participants
  'participants.list': 'lista',
  'participants.withBasePrice': 'zCenąBazową',
  'participants.withOptionsAndPrices': 'zOpcjamiICenami',
  'participants.withOptionsNoPrices': 'zOpcjamiBezCen',
  'participants.withBaseAndOptions': 'zCenąBazowąIOpcjami',
  'participants.withCustomFields': 'zPolamiDodatkowymi',
  'participants.withBaseOptionsAndCustomFields': 'zCenąOpcjamiIPolami',
  // legacy (camelCase) — kept in case other endpoints still return them
  participantsWithBasePrice: 'zCenąBazową',
  participantsWithOptionsAndPrices: 'zOpcjamiICenami',
  participantsWithOptionsNoPrices: 'zOpcjamiBezCen',
  participantsWithBaseAndOptions: 'zCenąBazowąIOpcjami',
  participantsWithCustomFields: 'zPolamiDodatkowymi',
  participantsWithBaseOptionsAndCustomFields: 'zCenąOpcjamiIPolami',

  // standalone
  expirationDate: 'dataWygaśnięcia',
  invitedByName: 'zapraszający',
  daysUntilStart: 'dniDoRozpoczęcia',
};

export const getVariableGroup = (key: string): string | null => {
  if (key.includes('.')) {
    return key.split('.')[0] ?? null;
  }
  if (key === 'participants' || /^participants[A-Z]/.test(key)) {
    return 'participants';
  }
  return null;
};

/**
 * Human-readable Polish label for a variable key, reusing the display-name map
 * as the single source of truth. Combines the group and field labels
 * (e.g. `booking.numer` → `rezerwacja.numer`); falls back to the raw key when
 * no mapping exists.
 */
export const getVariableLabel = (key: string): string => {
  const name = templateVariableDisplayNames[key];
  const group = getVariableGroup(key);
  const groupLabel = group ? templateVariableDisplayNames[group] : undefined;
  if (name && groupLabel) {
    return `${groupLabel}.${name}`;
  }
  return name ?? key;
};
